import { render, staticRenderFns } from "./ActionLinkToPayroll.vue?vue&type=template&id=ce0553b0"
import script from "./ActionLinkToPayroll.vue?vue&type=script&lang=js"
export * from "./ActionLinkToPayroll.vue?vue&type=script&lang=js"
import style0 from "./ActionLinkToPayroll.vue?vue&type=style&index=0&id=ce0553b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports